(function(){
  function clamp(v,min,max){ return Math.min(max,Math.max(min,v)); }

  function initGallery(root){
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumbnail]'));
    var track = root.querySelector('[data-gallery-track]');
    if(!slides.length || !track) return;

    var current = Math.max(0, slides.findIndex(function(s){ return s.classList.contains('is-active'); }));
    if(current < 0) current = 0;

    var mainCounter = root.querySelector('[data-gallery-counter]');
    var lightbox = root.querySelector('[data-product-lightbox]');
    var stage = root.querySelector('[data-lightbox-stage]');
    var lightboxImage = root.querySelector('[data-lightbox-image]');
    var counter = root.querySelector('[data-lightbox-counter]');
    var zoomLevel = root.querySelector('[data-zoom-level]');
    var scale = 1, panX = 0, panY = 0;
    var dragging = false, dragStartX = 0, dragStartY = 0, panStartX = 0, panStartY = 0;
    var lastFocused = null;
    var pinchStartDistance = null, pinchStartScale = 1;

    function activeData(){ return slides[current]; }

    function updateTrack(){
      track.style.transform = 'translate3d(' + (-current * 100) + '%,0,0)';
      slides.forEach(function(slide, i){
        slide.classList.toggle('is-active', i === current);
        slide.setAttribute('aria-hidden', i === current ? 'false' : 'true');
      });
      thumbs.forEach(function(x,i){
        x.classList.toggle('is-active', i === current);
        x.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
      if(mainCounter && slides.length > 1) mainCounter.textContent = (current + 1) + ' / ' + slides.length;
    }

    function updateZoomUI(){
      if(!lightboxImage) return;
      lightboxImage.style.transform = 'translate3d('+panX+'px,'+panY+'px,0) scale('+scale+')';
      lightboxImage.classList.toggle('is-zoomed', scale > 1.01);
      if(stage) stage.classList.toggle('is-zoomed', scale > 1.01);
      if(zoomLevel) zoomLevel.textContent = Math.round(scale * 100) + '%';
    }

    function resetZoom(){ scale = 1; panX = 0; panY = 0; updateZoomUI(); }
    function setZoom(next){
      scale = clamp(next, 1, 4);
      if(scale === 1){ panX = 0; panY = 0; }
      updateZoomUI();
    }

    function show(index){
      if(index < 0) index = slides.length - 1;
      if(index >= slides.length) index = 0;
      current = index;
      updateTrack();
      var d = activeData();
      if(lightboxImage){
        lightboxImage.src = d.dataset.full || d.dataset.large;
        lightboxImage.alt = d.dataset.alt || '';
      }
      if(counter && slides.length) counter.textContent = (current + 1) + ' / ' + slides.length;
      resetZoom();
    }

    slides.forEach(function(s,i){
      s.addEventListener('click', function(){
        current = i;
        updateTrack();
        openLightbox();
      });
    });

    thumbs.forEach(function(t,i){
      t.addEventListener('click', function(){ show(i); });
    });

    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    if(prev) prev.addEventListener('click', function(e){ e.stopPropagation(); show(current - 1); });
    if(next) next.addEventListener('click', function(e){ e.stopPropagation(); show(current + 1); });

    function openLightbox(){
      if(!lightbox || !lightboxImage) return;
      lastFocused = document.activeElement;
      show(current);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden','false');
      document.body.classList.add('lightbox-open');
      var close = root.querySelector('[data-zoom-close]');
      if(close) close.focus({preventScroll:true});
    }
    function closeLightbox(){
      if(!lightbox) return;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden','true');
      document.body.classList.remove('lightbox-open');
      resetZoom();
      if(lastFocused && lastFocused.focus) lastFocused.focus({preventScroll:true});
    }

    var zoomOpen = root.querySelector('[data-zoom-open]');
    var zoomClose = root.querySelector('[data-zoom-close]');
    var lbPrev = root.querySelector('[data-lightbox-prev]');
    var lbNext = root.querySelector('[data-lightbox-next]');
    var zoomIn = root.querySelector('[data-zoom-in]');
    var zoomOut = root.querySelector('[data-zoom-out]');
    var zoomReset = root.querySelector('[data-zoom-reset]');

    if(zoomOpen) zoomOpen.addEventListener('click', openLightbox);
    if(zoomClose) zoomClose.addEventListener('click', closeLightbox);
    if(lbPrev) lbPrev.addEventListener('click', function(){ show(current - 1); });
    if(lbNext) lbNext.addEventListener('click', function(){ show(current + 1); });
    if(zoomIn) zoomIn.addEventListener('click', function(){ setZoom(scale + .4); });
    if(zoomOut) zoomOut.addEventListener('click', function(){ setZoom(scale - .4); });
    if(zoomReset) zoomReset.addEventListener('click', resetZoom);

    if(stage){
      stage.addEventListener('wheel', function(e){
        if(!lightbox || !lightbox.classList.contains('is-open')) return;
        e.preventDefault();
        setZoom(scale + (e.deltaY < 0 ? .18 : -.18));
      }, {passive:false});

      stage.addEventListener('dblclick', function(e){
        e.preventDefault();
        setZoom(scale > 1 ? 1 : 2);
      });

      stage.addEventListener('pointerdown', function(e){
        if(scale <= 1) return;
        dragging = true;
        dragStartX = e.clientX; dragStartY = e.clientY;
        panStartX = panX; panStartY = panY;
        stage.setPointerCapture(e.pointerId);
        stage.classList.add('is-dragging');
      });
      stage.addEventListener('pointermove', function(e){
        if(!dragging) return;
        panX = panStartX + (e.clientX - dragStartX);
        panY = panStartY + (e.clientY - dragStartY);
        updateZoomUI();
      });
      function endDrag(e){
        if(!dragging) return;
        dragging = false;
        stage.classList.remove('is-dragging');
        try{ stage.releasePointerCapture(e.pointerId); }catch(err){}
      }
      stage.addEventListener('pointerup', endDrag);
      stage.addEventListener('pointercancel', endDrag);

      var touchStartX = null, touchStartY = null;
      stage.addEventListener('touchstart', function(e){
        if(e.touches.length === 2){
          pinchStartDistance = Math.hypot(
            e.touches[0].clientX - e.touches[1].clientX,
            e.touches[0].clientY - e.touches[1].clientY
          );
          pinchStartScale = scale;
          return;
        }
        if(scale > 1 || e.touches.length !== 1) return;
        touchStartX = e.touches[0].screenX;
        touchStartY = e.touches[0].screenY;
      }, {passive:true});
      stage.addEventListener('touchmove', function(e){
        if(e.touches.length === 2 && pinchStartDistance){
          var dist = Math.hypot(
            e.touches[0].clientX - e.touches[1].clientX,
            e.touches[0].clientY - e.touches[1].clientY
          );
          setZoom(pinchStartScale * (dist / pinchStartDistance));
        }
      }, {passive:true});
      stage.addEventListener('touchend', function(e){
        if(e.touches.length < 2){ pinchStartDistance = null; }
        if(scale > 1 || touchStartX === null || !e.changedTouches.length) return;
        var dx = e.changedTouches[0].screenX - touchStartX;
        var dy = e.changedTouches[0].screenY - touchStartY;
        if(Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.2 && slides.length){ show(dx > 0 ? current - 1 : current + 1); }
        touchStartX = null; touchStartY = null;
      }, {passive:true});
    }

    if(lightbox) lightbox.addEventListener('click', function(e){ if(e.target === lightbox) closeLightbox(); });

    document.addEventListener('keydown', function(e){
      if(!lightbox || !lightbox.classList.contains('is-open')) return;
      if(e.key === 'Escape') closeLightbox();
      if(e.key === 'ArrowLeft' && slides.length) show(current - 1);
      if(e.key === 'ArrowRight' && slides.length) show(current + 1);
      if(e.key === '+' || e.key === '=') setZoom(scale + .4);
      if(e.key === '-') setZoom(scale - .4);
      if(e.key === '0') resetZoom();
    });

    var pageStage = root.querySelector('[data-gallery-stage]');
    if(pageStage && slides.length){
      var swipeX = null, swipeY = null;
      pageStage.addEventListener('touchstart', function(e){
        if(e.touches.length !== 1) return;
        swipeX = e.touches[0].screenX; swipeY = e.touches[0].screenY;
      }, {passive:true});
      pageStage.addEventListener('touchend', function(e){
        if(swipeX === null || !e.changedTouches.length) return;
        var dx = e.changedTouches[0].screenX - swipeX;
        var dy = e.changedTouches[0].screenY - swipeY;
        if(Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.2) show(dx > 0 ? current - 1 : current + 1);
        swipeX = null; swipeY = null;
      }, {passive:true});
    }

    var variant = root.querySelector('[data-variant-select]');
    var price = root.querySelector('[data-product-price]');
    if(variant && price){
      variant.addEventListener('change', function(){
        var opt = variant.options[variant.selectedIndex];
        if(opt && opt.dataset.price) price.textContent = opt.dataset.price;
      });
    }

    var qty = root.querySelector('[data-qty-input]');
    var qtyMinus = root.querySelector('[data-qty-minus]');
    var qtyPlus = root.querySelector('[data-qty-plus]');
    if(qty && qtyMinus) qtyMinus.addEventListener('click', function(){ qty.value = Math.max(1, parseInt(qty.value || '1',10) - 1); });
    if(qty && qtyPlus) qtyPlus.addEventListener('click', function(){ qty.value = Math.max(1, parseInt(qty.value || '1',10) + 1); });

    show(current);
  }

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('[data-product-gallery]').forEach(initGallery);
  });
})();
